module.exports = __webpack_public_path__ + "img/Warrior-orc-m-70.dc4cad9d.gif";